var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('badge',{staticClass:"badge-dot mr-2"},[_c('i',{class:_vm.badgesColor})]),_vm._v("\n  "+_vm._s(_vm.statusTranslate)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }